import React from "react";

import { useTranslation } from "core/hooks/useTranslation";

import CommissionStatus from "core/ui-kit/commissionStatus";

import classNames from "core/helpers/common/classNames";

import { COMMISSION_TYPE_TRANSLATIONS } from "core/constants/commission/type";
import dateService from "core/services/dateService";
import CommissionType from "../commissionTypeStatus";
import {COMMISSION_PLAN_STATE_COLORS, COMMISSION_PLAN_STATE_TRANSLATIONS} from "core/global/commissions/constants.js";

const Navigation = ({
    items,
    selected,
    onClick,
}) => {
    const { t } = useTranslation();
    
    return (
        <div className="rt--commissions-navigation">
            {
                items.map((item) => {
                    const { startDate, endDate, affiliateCommissionPlanId, affiliateCommissonPlanStatus } = item;
                    const isSelected = affiliateCommissionPlanId === selected?.affiliateCommissionPlanId;
                    const startDateValue = startDate ? dateService.format(startDate) : '-';
                    const endDateValue = endDate ? dateService.format(endDate) : '-';
                    return (
                        <div
                            className={classNames("rt--nav-item", isSelected && "i-selected")}
                            key={affiliateCommissionPlanId}
                            title={item.name}
                            onClick={() => onClick(item)}
                        >
                            <div className="rt--nav-item-head">
                                <div className="rt--info-row">
                                    <div className="rt--commission-name rt--font-extra-bold rt--font-normal">
                                        {item.name}
                                    </div>
                                    <CommissionStatus
                                        status={affiliateCommissonPlanStatus}
                                        colors={COMMISSION_PLAN_STATE_COLORS}
                                        labels={COMMISSION_PLAN_STATE_TRANSLATIONS}
                                    />
                                </div>
                                <div className="rt--flex rt--align-center">
                                    <span
                                        className="rt--commissions-navigation-item-currency rt--font-regular rt--font-normal rt--pr-12">
                                        {item.currencyCode}
                                    </span>
                                    <CommissionType
                                        type={item.type}
                                        label={t(COMMISSION_TYPE_TRANSLATIONS[item.type])}
                                    />
                                </div>
                            </div>
                            <div className="rt--commission-dates">
                                <div className="rt--commissions-dates-row">
                                    <span className="rt--font-small rt--text-light rt--font-bold">{t('backoffice.commissionplans.startDate')}</span>
                                    <span>{startDateValue}</span>
                                </div>
                                <div className="rt--commissions-dates-row">
                                    <span className="rt--font-small rt--text-light rt--font-bold">{t('backoffice.commissionplans.endDate')}</span>
                                    <span>{endDateValue}</span>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Navigation;